import z from "zod";

/**
 * SatisfacaoClienteSchema
 */

export const SatisfacaoClienteSchema = z.object({
  status: z.coerce.number({ required_error: 'Este campo deve ser preenchido!', invalid_type_error: 'Este campo deve ser preenchido!' }).default(0),
  centroCusto: z.coerce.number({ required_error: 'Este campo deve ser preenchido!', invalid_type_error: 'Este campo deve ser preenchido!' }),
  cliente: z.coerce.number().nullable().default(null),
  nomeCliente: z.string().nullable().default(null),
  preencher: z.coerce.boolean().default(false),
  data: z.coerce.date().nullable().default(null),
}).superRefine((data, ctx) => {
  if (data.preencher) {
    if (data.nomeCliente === null || data.nomeCliente.length === 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Este campo deve ser preenchido!',
        path: ['nomeCliente'],
      });
    }
  } else {
    if (data.cliente === null || data.cliente === 0) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Este campo deve ser preenchido!',
        path: ['cliente'],
      });
    }
  }
});

/**
 * SatisfacaoClienteForm
 */

export type SatisfacaoClienteForm = z.infer<typeof SatisfacaoClienteSchema>;

/**
 * initialSatisfacaoClienteForm
 */

export const initialSatisfacaoClienteForm: Partial<SatisfacaoClienteForm> = {
  status: 0,
  preencher: false,
  data: null,
};